import React from 'react';
import type { COLOR_NAMES } from '~go/web/src/js/constants/colors';
import { clsx } from '../../../utils/clsx/clsx';
import './icon.css';

export type IconVariant = 'solid' | 'regular' | 'light' | 'thin' | 'duotone';
export type ColorName = typeof COLOR_NAMES[number];

interface IconProps {
  variant?: IconVariant;
  icon: string;
  size?: string | number;
  style?: React.CSSProperties;
  className?: string;
  color?: ColorName;
}

export default function Icon({
  variant = 'regular',
  icon,
  size = 'inherit',
  style,
  className,
  color = 'inherit',
}: IconProps) {
  const variantMap: Record<IconVariant, string> = {
    solid: 's',
    regular: 'r',
    light: 'l',
    thin: 't',
    duotone: 'd',
  };

  return (
    <i
      className={clsx('custom-icon', `fa${variantMap[variant]} fa-${icon}`, className)}
      style={{ fontSize: size, color: color !== 'inherit' ? `var(--${color})` : 'inherit', ...style }}
    />
  );
}
